import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

import { Attachment, JobStatus } from '@assess/browser/api';
import { Nullable } from '@assess/shared/type-utilities';

import { IFormSnapshotAttachment } from './form-snapshot-attachment.interface';

@Component({
  selector: 'assess-pdf-history-list',
  templateUrl: './pdf-history-list.component.html',
  styleUrls: ['./pdf-history-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class PdfHistoryListComponent {
  @Input() historyPdfs?: Nullable<IFormSnapshotAttachment[]>;
  @Output() readonly pdfHistoryListShow = new EventEmitter<Attachment>();
  @Input() hideFormCentricComponents!: Nullable<boolean>;
  @Input() displaySubmissionHistory!: Nullable<boolean>;

  readonly JobStatus = JobStatus;

  showPdf(attachment: Attachment) {
    this.pdfHistoryListShow.emit(attachment);
  }
}
